export default "__VITE_ASSET__ClQn4YZ5__"